import { TooltippedIcon } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { FormInputField, FormInputFieldProps, lt } from '@mews/framework';
import { ServiceTimeClass } from '@mews/enums';

interface TimeUnitSuffixProps {
    timeUnit?: ServiceTimeClass;
}

const TimeUnitSuffix = ({ timeUnit }: TimeUnitSuffixProps) => {
    switch (timeUnit) {
        case 'Month':
            return lt('Months');
        case 'Day':
            return lt('Days');
        case 'Night':
            return lt('NightPlural');
        case 'Hour':
            return lt('Hours');
        default:
            return null;
    }
};

interface MaximumTimeForPaymentFieldProps extends TimeUnitSuffixProps, Pick<FormInputFieldProps, 'name'> {
    autoFocus?: boolean;
}

export const MaximumTimeForPaymentField = ({ autoFocus, name, ...other }: MaximumTimeForPaymentFieldProps) => (
    <FormInputField
        autoFocus={autoFocus}
        size="medium"
        label={lt('PaymentMaximumTime')}
        name={name}
        captionIconWithTooltip={
            <TooltippedIcon size="small" value={IconName.Help} tooltip={TextKey.PaymentMaximumTimeUnitsHint} />
        }
        suffix={<TimeUnitSuffix {...other} />}
        type="number"
    />
);
